angular.module('impactx.rfx').controller('RFXListOffersSupportCtrl', [
    '$scope',
    '$redirect',
    'selectedListItems',
    '$routeParams',
    'TranslationService',
    'ConfirmationService',
    'dataGen',
    'ToastService',
    '$route',
    'RFXBuyerService',
    RFXListOffersSupportCtrl]);

function RFXListOffersSupportCtrl($scope, $redirect, selectedListItems, $routeParams, TranslationService, ConfirmationService, dataGen, ToastService, $route, RFXBuyerService) {
    var self = this;
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: canViewOffer,
            process: 'RFXRequestSupportView'
        },
        {
            label: "sendRFQ",
            action: sendRFQ,
            condition: canSendRFQ,
            type: 'dialogaction',
            process: 'RFXRequestSupportView'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/rfx/templates/rfx-list-offers.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/list/offers',
        id: "rfxlistoffers",
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: "RFQH_Id", value: $routeParams.rfqhId}],
    };

    self.getMeta = function () {
        return this.meta;
    };

    function sendRFQ() {
        var item = selectedListItems.getFirstSelectedItem();
        var params = {
            rfqhId: $routeParams.rfqhId,
            rfqsId: item.id,
            mode: item.canSendRFQ.mode
        };
        ToastService.openStandardToast(item.canSendRFQ.exportStarted);
        dataGen.postAsForm({}, params, "/rfx/request/export").then(function () {
            $route.reload();
        });
    }

    function canSendRFQ() {
        return selectedListItems.isSingleSelection && selectedListItems.getFirstSelectedItem().canSendRFQ.value;
    }

    function getDetailLink() {
        return "rfx/offer/support/" + selectedListItems.getFirstSelectedId();
    }

    function canViewOffer() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canViewOffer.value;
    }
}